<template>
  <div>
    <b-card>
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
        >
          <template #cell(actions)="{item}">
            <div class="d-flex align-items-center gap-2">
              <b-button
                variant="success"
                size="sm"
                :disabled="db"
                @click="handleAccept(item.id)"
              >
                {{$t('modal.button.accept')}}
              </b-button>

              <b-button
                variant="danger"
                size="sm"
                :disabled="db"
                @click="handleReject(item.id)"
              >
                {{$t('modal.button.reject')}}
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'Manager-Notification',
    data() {
      return {
        items: [],
        fields:[
          {
            key: 'id', 
            label: '№'
          },
          {
            key: 'driver.full_name', 
            label: this.$t('table.driver.label')
          },
          {
            key: 'driver.debt',
            label: this.$t('modal.form.debt')
          },
          {
            key: 'actions', 
            label: this.$t('table.actions.label')
          },
        ],
        db: false,
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        // eslint-disable-next-line no-console
        console.table('new data');
      },
      handleAccept(id) {
        id
      },
      handleReject(id) {
        id
      }
    }
  }
</script>